import { type LegalEntityConstructor } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { type LegalEntityApiModel } from '../api-models/LegalEntityApiModel'

export const mapLegalEntityApiModel = (
  apiModel: LegalEntityApiModel
): LegalEntityConstructor => ({
  id: apiModel.id,
  uuid: apiModel.uuid,
  name: apiModel.name,
  baseCurrencyId: apiModel.base_currency.id,
  baseCurrencyName: apiModel.base_currency.name,
  country: apiModel.country,
  externalId: apiModel.external_id ?? '',
  active: apiModel.active,
  createdAt: new Date(apiModel.created_at),
  updatedAt: new Date(apiModel.updated_at),
  locationCount: apiModel.assigned_locations_count,
  inboxEmailAddress: apiModel.inbox_email_address ?? '',
})
